/**
 * store/index.js getVariables
 * @param {Store} store 需要注入变量的store
 */

export function apiAddon(store) {
  const { variables } = store;
  // 重构form结构
  Object.keys(variables)
    .filter(key => key[0] !== '$')
    .forEach((key) => {
      if (
        variables[`$${key}`]
        && variables[`$${key}`].isState
        && !('value' in variables[key])
        && variables[key].fieldData
      ) {
        variables[key].value = variables[key].fieldData.value;
      }
    });
}

export function proxyState(obj) {
  if (obj && typeof obj === 'object') {
    if (obj.fieldData && 'value' in obj.fieldData) {
      obj.value = obj.fieldData.value;
    }
    if (obj.behavior && obj.behavior.fieldBehavior) {
      obj.behavior = obj.behavior.fieldBehavior;
    }
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        proxyState(obj[key]);
      }
    }
  }
  return obj;
}

export function proxyScope(store, scope, appendVariables) {
  const { context } = store;
  const { dp } = context;
  return {
    ...dp.variables,
    ...proxyState(scope.getValue()),
    ...proxyState((appendVariables || {})),
  };
}
